"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalizedTableValues = {
    en: {
        selectAll: "Select all",
        deselectAll: "Deselect all",
        rowsSelected: function (selected, total, rowDescriptor) { return selected + " of " + total + " " + rowDescriptor + " selected"; },
    },
};
exports.default = LocalizedTableValues;
//# sourceMappingURL=i18n.js.map